"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = ProgressBar;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const class_variance_authority_1 = require("class-variance-authority");
const ProgressBarVariants = (0, class_variance_authority_1.cva)("ko:h-full ko:w-full", {
    variants: {
        color: {
            primary: "ko:bg-primary",
            neutral: "ko:bg-neutral",
        },
        corner: {
            rounded: "",
            sharp: "",
        },
    },
    defaultVariants: {
        color: "primary",
        corner: "rounded",
    },
});
function ProgressBar({ value, color, corner }) {
    const width = value > 100 ? 100 : value < 0 ? 0 : value;
    return ((0, jsx_runtime_1.jsx)("div", { role: "progressbar", "aria-valuenow": width, "aria-valuemin": 0, "aria-valuemax": 100, className: (0, utilities_1.twMerge)("ko:h-1.5 ko:w-full ko:overflow-hidden ko:bg-neutral-inactive", corner === "rounded" ? "ko:rounded-full" : ""), children: (0, jsx_runtime_1.jsx)("div", { className: (0, utilities_1.twMerge)(ProgressBarVariants({ color, corner })), style: { width: `${width}%` } }) }));
}
